<template>
  <li @click="handleClick">
    <div
      class="pic"
      v-lazy:background-image="handleImg({ url: bg, width: 654, height: 654 })"
    >
      <div class="detail-bg-box"></div>
      <img
        class="i-play global_pointer"
        :src="
          handleImg({
            url: 'https://fr-static.shopshops.top/20200328/icon_play56x56@2x.07a400e47d571826.png',
            width: 56,
            height: 56,
            format: 'png',
          })
        "
        alt="播放按钮"
      />
         <!-- <div
                    v-if="item.liveStatus.code === 2"
                    class="live-icon live">
                    <img src="@/assets/imgs/anchor/livestatus.png" alt="">
                    <span>{{ $t('message.anchor.live') }}</span>
                  </div> -->

          <div
            class="item-content-title"
            v-if="item.countryName || item.cityName"
        >
            <img
                class="item-content-title-icon"
                src="https://fr-static.shopshops.top/20200328/icon_home_shop_address_white14x14@3x.123ad92fe39e1602.png"
                alt=""
            />
            <span v-if="item.countryName">{{ item.countryName }}</span>
            <span style="margin: 0 4px;">|</span>
            <span v-if="item.cityName">{{ item.cityName }}</span>
        </div>

      <span class="detail">{{
        `${item.maxUserNum} ${watchText} I ${item.merchandiseNum} ${productsText}`
      }}</span>
    </div>
    <div class="intro">
      <h3>{{ item.liveName }}</h3>

      <span>{{ formatTime }}</span>
      <div class="intro-right">
        <img
          class="anchor-avatar"
          v-lazy="handleImg({ url: avatar, width: 48, height: 48 })"
          alt="头像"
        />
        <div>{{ item.hostName }}</div>
      </div>

    </div>
  </li>
</template>
<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      lanType: navigator.language.includes("zh"),
    };
  },
  computed: {
    formatTime() {
      const time = (this.item.startTime || { seconds: 0 }).seconds * 1000;

      return this.$moment(new Date(time)).format('MMMM D, yyyy, h:mmA')
    },
    bg() {
      return (this.item.liveImg || {}).url;
    },
    avatar() {
      return (this.item.hostImage || {}).url;
    },
    watchText() {
      return this.$t("message.store.watch");
    },
    productsText() {
      return this.$t("message.store.products");
    },
  },
  methods: {
    handleClick() {
      this.$router.push({
          path: '/app/room/'+this.item.id,
      })
    },
  },
};
</script>
<style lang="less" scoped>
img {
  display: block;
}
li {
  margin: 12px 0;
  border-radius: 8px;
  overflow: hidden;
  .pic {
    margin: 0 auto;
    position: relative;
    width: 327px;
    height: 327px;
    border-radius: 8px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .detail-bg-box {
      width: 100%;
      height: 48px;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity: 0.45;
      background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.45) 23%,
        rgba(0, 0, 0, 0) 100%
      );
      border-radius: 8px;
    }
    .i-play {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 28px;
      height: 28px;
      transform: translate(-50%, -50%);
    }
    .detail {
      position: absolute;
      right: 8px;
      bottom: 8px;
      font-size: 12px;
      line-height: 17px;
      color: #fff;
      font-family: "TradeGothicLT";
    }
  }
  .live-icon{
        position: absolute;
        top: 8px;
        left: 8px;
        padding: 0 8px;
        height: 19px;
        text-align: center;
        line-height: 19px;
        color: #39D2D6;
        border-radius: 4px;
        font-size: 12px;
        font-family: 'TradeGothicLT-Bold';
        background-color: #000000;
        img{
            width: 10px;
            height: 10px;
            line-height: 19px;
            margin-right: 2.5px;
        }
    }
  .intro {
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 8px 8px 8px 12px;
    text-align: left;
    h3 {
      font-size: 14px;
      line-height: 20px;
      color: #666666;
      overflow: hidden;
    }
    span {
      margin-top: 2px;
      font-size: 12px;
      line-height: 17px;
      color: #666666;
      margin-top: 2.5px;
      font-family: "TradeGothicLT";
    }
    .intro-right {
      margin-top: 2.5px;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #666666;
      .anchor-avatar {
        width: 24px;
        height: 24px;
        margin-right: 4px;
        border-radius: 50%;
      }
    }
  }


  .item-content-title {
      font-size: 12px;
      color: #fff;
      position: absolute;
      top: 8px;
      right: 8px;
      display: flex;
      align-content: center;
      align-items: center;
      font-family: "TradeGothicLT";
      &-icon {
          width: 14px;
          height: 14px;
          margin-right: 3px;
      }
  }
}
</style>
